// This code was brought in from marketing-hub as js files and is not currently
// type safe so leaving as js for now

const dummyQuiet = () => {};
const amplitudeApiKey = 'cc1dfb7fb3c02af5b126913f086cf922';

const dummy = (type = '') => (...args) => {
    console.log(`Dummy ${type}`, ...args);
};

function dummyGetInstance() {
    return {
        init: dummyQuiet,
        logEvent: dummyQuiet,
        logRevenueV2: dummyQuiet,
        identify: dummyQuiet,
        Identify: () => ({
            set: dummyQuiet,
        }),
        setUserId: dummyQuiet,
        setUserProperties: dummyQuiet,
    };
}

function setAmplitudeStub() {
    window.amplitude = {
        getInstance: dummyGetInstance,
        identify: dummyQuiet,
        Identify: () => ({
            set: dummyQuiet,
        }),
        Revenue: () => dummyQuiet,
    };
}

export function getAmplitudeInstance() {
    if (typeof window === 'undefined') {
        return dummyGetInstance();
    }

    if (!window.amplitude) {
        return dummyGetInstance();
    }

    return window.amplitude.getInstance();
}

export function loadAmplitude() {
    if (process.env.NODE_ENV !== 'production') {
        setAmplitudeStub();
    } else if (window.amplitude) {
        return;
    } else {
        (function (e, t) {
            var n = e.amplitude || { _q: [], _iq: {} };
            var r = t.createElement('script');
            r.type = 'text/javascript';
            r.integrity =
                'sha384-u0hlTAJ1tNefeBKwiBNwB4CkHZ1ck4ajx/pKmwWtc+IufKJiCQZ+WjJIi+7C6Ntm';
            r.crossOrigin = 'anonymous';
            r.async = true;
            r.src = 'https://cdn.amplitude.com/libs/amplitude-8.1.0-min.gz.js';
            r.onload = function () {
                if (!e.amplitude.runQueuedFunctions) {
                    console.log('[Amplitude] Error: could not load SDK');
                }
            };
            var i = t.getElementsByTagName('script')[0];
            i.parentNode.insertBefore(r, i);
            function s(e, t) {
                e.prototype[t] = function () {
                    this._q.push(
                        [t].concat(Array.prototype.slice.call(arguments, 0)),
                    );
                    return this;
                };
            }
            var o = function () {
                this._q = [];
                return this;
            };
            var a = [
                'add',
                'append',
                'clearAll',
                'prepend',
                'set',
                'setOnce',
                'unset',
                'preInsert',
                'postInsert',
                'remove',
            ];
            for (var c = 0; c < a.length; c++) {
                s(o, a[c]);
            }
            n.Identify = o;
            var u = function () {
                this._q = [];
                return this;
            };
            var l = [
                'setProductId',
                'setQuantity',
                'setPrice',
                'setRevenueType',
                'setEventProperties',
            ];
            for (var p = 0; p < l.length; p++) {
                s(u, l[p]);
            }
            n.Revenue = u;
            var d = [
                'init',
                'logEvent',
                'logRevenue',
                'setUserId',
                'setUserProperties',
                'setOptOut',
                'setVersionName',
                'setDomain',
                'setDeviceId',
                'enableTracking',
                'setGlobalUserProperties',
                'identify',
                'clearUserProperties',
                'setGroup',
                'logRevenueV2',
                'regenerateDeviceId',
                'groupIdentify',
                'onInit',
                'logEventWithTimestamp',
                'logEventWithGroups',
                'setSessionId',
                'resetSessionId',
            ];
            function v(e) {
                function t(t) {
                    e[t] = function () {
                        e._q.push(
                            [t].concat(
                                Array.prototype.slice.call(arguments, 0),
                            ),
                        );
                    };
                }
                for (var n = 0; n < d.length; n++) {
                    t(d[n]);
                }
            }
            v(n);
            n.getInstance = function (e) {
                e = (!e || e.length === 0
                    ? '$default_instance'
                    : e
                ).toLowerCase();
                if (!Object.prototype.hasOwnProperty.call(n._iq, e)) {
                    n._iq[e] = { _q: [] };
                    v(n._iq[e]);
                }
                return n._iq[e];
            };
            e.amplitude = n;
        })(window, document);
    }

    window.amplitude.getInstance().init(amplitudeApiKey, null, {
        includeUtm: true,
        includeReferrer: true,
        saveEvents: true,
    });
}

export function loadIntercom() {
    if (process.env.NODE_ENV !== 'production') {
        window.Intercom = dummy('intercom');
    } else if (window.Intercom) {
        return;
    } else {
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === 'function') {
                ic('reattach_activator');
                ic('update', {
                    app_id: 'xlku466w',
                    custom_launcher_selector: '.help-launcher',
                });
            } else {
                var d = document;
                var i = function () {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                function l() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/xlku466w';
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                }
                // THIS PART IS CUSTOMIZED, DO NOT REPLACE THE INTERCOM INSTALLATION TAG UNTIL YOU UNDERSTAND WHAT THIS DOES
                // In the marketing hub, this installation script runs after the window has loaded. I've added the first if
                // condition here to handle the case where the window has already loaded when the installation script runs.
                // Stolen from https://stackoverflow.com/questions/13364613/how-to-know-if-window-load-event-was-fired-already/28093606.
                if (
                    performance &&
                    performance
                        .getEntriesByType('navigation')
                        .every((e) => e.loadEventEnd)
                ) {
                    l();
                } else if (w.attachEvent) {
                    w.attachEvent('onload', l);
                } else {
                    w.addEventListener('load', l, false);
                }
            }
        })();
    }
}

export function identifyIntercom() {
    const eventbriteUser = window.__SERVER_DATA__?.user;
    const intercomUserHash = window.__SERVER_DATA__?.intercomUserHash;

    if (eventbriteUser && intercomUserHash) {
        window.Intercom('boot', {
            app_id: 'xlku466w',
            name: eventbriteUser.fullName,
            email: eventbriteUser.email,
            user_hash: intercomUserHash,
            user_type: 'manager',
            admin_email: eventbriteUser.email,
            eventbrite_username: eventbriteUser.fullName,
            eventbrite_organization_id:
                eventbriteUser.activeOrganization &&
                eventbriteUser.activeOrganization.id,
            creation_platform: 'eventbrite',
            utm_source: window.utm_source,
            utm_campaign: window.utm_campaign,
            utm_medium: window.utm_medium,
        });
    }
}

export function trackIntercomEvent(message, object) {
    window.Intercom('trackEvent', message, object);
}

export function intercomUpdate(params) {
    window.Intercom('update', params);
}
